import React, { memo } from 'react'

import { Button, Icon, CircleX, RefreshOutline } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const errorIcon = (
  <Icon svgComponent={CircleX} size={iconSize} notSpaced className="image-assistant-create-tab__error-icon" />
)

const retryIcon = <Icon svgComponent={RefreshOutline} size={iconSize} notSpaced color="darker" />

// Failed turn: danger title, explanation and a "Generate again" retry chip.
function FailedState({ onGenerateAgain }) {
  const t = useTranslation()

  return (
    <div className="image-assistant-create-tab__failed">
      <span className="image-assistant-create-tab__failed-title cgt-body-base-semibold">
        {errorIcon}
        {t('imageAssistantPanel.createTab.failedState.title')}
      </span>
      <p className="image-assistant-create-tab__failed-text cgt-body-base">
        {t('imageAssistantPanel.createTab.failedState.text')}
      </p>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-assistant-create-tab__failed-retry"
        icon={retryIcon}
        onClick={onGenerateAgain}
      >
        {t('imageAssistantPanel.createTab.failedState.retry')}
      </Button>
    </div>
  )
}

FailedState.propTypes = {
  onGenerateAgain: func.isRequired,
}

export default memo(FailedState)
